import { createSvgIcon } from '@mui/material';

export const ScanQRIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="currentColor"
      d="M1 3.75A2.75 2.75 0 0 1 3.75 1H6.5v1.833H3.75a.917.917 0 0 0-.917.917V6.5H1V3.75ZM17.5 1h2.75A2.75 2.75 0 0 1 23 3.75V6.5h-1.833V3.75a.917.917 0 0 0-.917-.917H17.5V1ZM1 20.25V17.5h1.833v2.75c0 .506.41.917.917.917H6.5V23H3.75A2.75 2.75 0 0 1 1 20.25ZM21.167 20.25V17.5H23v2.75A2.75 2.75 0 0 1 20.25 23H17.5v-1.833h2.75c.506 0 .917-.41.917-.917ZM5.583 5.583h5.5v5.5h-5.5v-5.5Zm1.834 1.834V9.25H9.25V7.417H7.417ZM12.917 5.583h5.5v5.5h-5.5v-5.5Zm1.833 1.834V9.25h1.833V7.417H14.75ZM5.583 12.917h5.5v5.5h-5.5v-5.5Zm1.834 1.833v1.833H9.25V14.75H7.417ZM12.917 12.917h2.2v1.65h1.1v-1.65h2.2v2.2h-1.65v1.1h1.65v2.2h-2.2v-1.65h-1.65v-1.65h-1.65v-2.2Z"
    />
  </svg>,
  'ScanQRIcon',
);
